<template>
  <v-row>
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>

    <v-dialog v-model="similarWarehouseItemsDialog" width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>مشاهده محصولات مشابه با {{ selectedProduct.description }}</h4>
        </v-card-title>
        <v-card-text>
          <b-table
            responsive
            small
            show-empty
            :items="similarWarehouseItems"
            :fields="similarWarehouseItemsFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary mt-8"
            style="font-family: Tahoma !important"
          >
            <template v-slot:head()="data">
              <div
                dir="ltr"
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma !important;
                  padding: 3px 5px;
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                dir="ltr"
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma !important;
                  padding: 7px 5px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma !important;
                  padding: 7px 5px;
                "
              >
                {{ data.index + 1 }}
              </div>
            </template>
          </b-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-col cols="12">
      <b-tabs pills card content-class="border-0">
        <b-tab title="عمومی" active>
          <b-card
            class="shadow"
            header-bg-variant="secondary"
            header-text-variant="white"
          >
            <template v-slot:header>
              <v-row>
                <v-col cols="7" class="mt-4">
                  <h4>کد ردیابی: {{ factoryOrderInfo.factoryCode }}</h4>
                  <h5>نام مشتری: {{ factoryOrderInfo.customerName }}</h5>
                  <h4>وضعیت سفارش: {{ factoryOrderInfo.factoryStatus }}</h4>
                  <a
                    v-if="role == 'Manager'"
                    :href="'/Manager/order/' + $route.params.id"
                    target="_blank"
                    class="btn btn-primary"
                    >مشاهده پرونده استعلام</a
                  >
                </v-col>
                <v-col cols="5" class="mt-4">
                  <v-col>
                    <v-row>
                      <v-col>
                        <v-progress-circular
                          :rotate="270"
                          :size="110"
                          :width="6"
                          :value="factoryOrderInfo.progress"
                          color="cyan"
                        >
                          {{ factoryOrderInfo.progress }}%
                        </v-progress-circular>
                        <!-- <h5>
                          درصد پیشرفت کار: {{ factoryOrderInfo.progress }} %
                        </h5> -->
                      </v-col>
                    </v-row>
                  </v-col>
                </v-col>
              </v-row>
              <hr />
            </template>
            <v-row>
              <v-col cols="12">
                <b-card class="my-0 h-100">
                  <template v-slot:header>
                    <h5 class="my-0">
                      فرم سفارش ساخت
                      <b-button
                        v-show="
                          role == 'Manager' ||
                          role == 'factory' ||
                          role == 'trade' ||
                          role == 'tradeHead' ||
                          role == 'salesManager'
                        "
                        @click="factoryModal()"
                        variant="primary"
                        class="text-white mx-1"
                        >ویرایش فرم ساخت</b-button
                      >
                      <b-button
                        v-show="role == 'Manager' || role == 'factory'"
                        @click="changeOrderStatusDialogModal()"
                        variant="warning"
                        class="text-white mx-1"
                        >ویرایش وضعیت سفارش</b-button
                      >
                      <b-button
                        v-show="
                          role == 'Manager' ||
                          role == 'factory' ||
                          role == 'factoryTechnical' ||
                          role == 'factoryGeneral'
                        "
                        @click="printForm()"
                        class="text-white mx-1 purple"
                        >چاپ فرم</b-button
                      >

                      <b-button
                        v-if="role == 'Manager' || role == 'salesManager'"
                        :href="'/factory/editOrder/' + $route.params.id"
                        target="_blank"
                        class="btn btn-success mx-1"
                        >ویرایش قیمت سفارش</b-button
                      >
                      <b-button
                        v-if="
                          role == 'Manager' ||
                          role == 'salesManager' ||
                          role == 'trade' ||
                          role == 'tradeHead'
                        "
                        :href="'/factory/editOrderItems/' + $route.params.id"
                        target="_blank"
                        class="btn btn-dark mx-1"
                        >ویرایش اقلام سفارش</b-button
                      >
                    </h5>
                  </template>
                  <table
                    class="orderInfoTable"
                    border="1px"
                    style="width: 100%"
                  >
                    <tr>
                      <th class="p-1">کد ردیابی</th>
                      <td class="p-1">{{ factoryOrderInfo.factoryCode }}</td>
                    </tr>
                    <tr>
                      <th class="p-1">نام مشتری</th>
                      <td class="p-1">{{ factoryOrderInfo.customerName }}</td>
                    </tr>
                    <tr>
                      <th class="p-1">شماره درخواست مشتری</th>
                      <td class="p-1">
                        {{ factoryOrderInfo.originalRequestId }}
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">تعداد اقلام سفارش</th>
                      <td class="p-1">{{ factoryOrderInfo.factoryCount }}</td>
                    </tr>
                    <tr>
                      <th class="p-1">بسته‌بندی</th>
                      <td class="p-1">{{ factoryOrderInfo.factoryPackage }}</td>
                    </tr>
                    <tr>
                      <th class="p-1">پوشش</th>
                      <td class="p-1">{{ factoryOrderInfo.factoryCoating }}</td>
                    </tr>
                    <tr>
                      <th class="p-1">زمان تحویل</th>
                      <td class="p-1">
                        {{ factoryOrderInfo.factoryDeliveryDuration }}
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">محل تحویل</th>
                      <td class="p-1">
                        {{ factoryOrderInfo.factoryDeliveryLocation }}
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">هزینه حمل</th>
                      <td class="p-1">
                        {{ factoryOrderInfo.factoryDeliveryCost }}
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">نام نماینده مشتری</th>
                      <td class="p-1">
                        {{ factoryOrderInfo.factoryCustomerAgentName }}
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">بازرسی</th>
                      <td class="p-1">
                        {{ factoryOrderInfo.factoryInspection }}
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">وزن</th>
                      <td class="p-1">{{ factoryOrderInfo.factoryWeight }}</td>
                    </tr>
                    <tr>
                      <th class="p-1">شماره تماس مشتری</th>
                      <td class="p-1">{{ factoryOrderInfo.factoryPhone }}</td>
                    </tr>
                    <tr>
                      <th class="p-1">سایر توضیحات</th>
                      <td class="p-1">
                        {{ factoryOrderInfo.factoryOtherDescriptions }}
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">آدرس تحویل</th>
                      <td class="p-1">
                        {{ factoryOrderInfo.factoryDeliveryAddress }}
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">تاریخ ابلاغ</th>
                      <td class="p-1">{{ factoryOrderInfo.factoryDate }}</td>
                    </tr>
                  </table>
                </b-card>
              </v-col>
            </v-row>
          </b-card>
        </b-tab>
        <b-tab title="فایل‌ها">
          <b-card
            header-bg-variant="secondray"
            header-text-variant="white"
            header="جدول فایل‌های آپلود شده"
            class="shadow p-3 mb-5 bg-white rounded"
          >
            <template v-slot:header>
              <h6>
                <b-input-group size="md">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                      variant="danger"
                      >حذف</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </h6>
            </template>
            <b-table
              responsive
              :items="
                factoryOrderFiles ? factoryOrderFiles.filter((x) => x) : ''
              "
              :fields="fields"
              show-empty
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :busy="isBusy"
              :filter="filter"
            >
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + perPage * (currentPage - 1) + 1 }}
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:cell(actions)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    class="btn btn-success text-white"
                    :href="data.item.url"
                    role="button"
                    target="blank"
                  >
                    <i class="fa fa-download" aria-hidden="true"></i>
                    دریافت</a
                  >
                  &nbsp;
                  <b-btn variant="danger" @click="delFile(data.item)">
                    <i class="fa fa-remove" aria-hidden="true"></i>
                    حذف</b-btn
                  >
                  <!-- v-if="
                      role == 'Manager' ||
                      role == 'factory' ||
                      (data.item.uploader == currentUserId &&
                        data.item.date ==
                          moment(new Date()).format('jYYYY/jMM/jDD'))
                    " -->
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-form-group label="بارگذاری فایل:">
              <b-form-file
                :state="Boolean(uploadedFiles.length)"
                @input="upload(file)"
                v-model="file"
                browse-text="آپلود"
                placeholder="فایل مربوطه را آپلود کنید"
                accept="*"
              ></b-form-file>
            </b-form-group>
            <br />
            <b-progress
              v-if="myFile.showProgress"
              :value="myFile.uploadPercentage"
              :max="max"
              show-progress
              :animated="myFile.striped"
              :variant="myFile.variant"
            ></b-progress>
            <v-row>
              <br />
              <div v-if="myFile.isUploaded" color="green" class="mt-4 mr-3">
                فایل با موفقیت آپلود شد.
              </div>
              <br />
            </v-row>
          </b-card>
        </b-tab>
        <b-tab title="تاریخچه">
          <v-card class="" header-bg-variant="primary" bg-variant="white">
            <v-card-title>
              <h5>
                کاربر گرامی، کلیه تغییراتی که روی کار انجام شده است در این بخش
                قابل مشاهده می‌باشد
              </h5>
            </v-card-title>

            <v-row class="mb-4"></v-row>
            <v-row v-for="item in history" :key="item.id" class="mt-3">
              <v-col cols="1"></v-col>
              <v-col cols="1"></v-col>
              <v-col cols="10">
                <b-card
                  text-variant="light"
                  bg-variant="primary"
                  style="max-width: 80%"
                  class="shadow-lg p-0 mb-0 rounded h-100"
                >
                  <template v-slot:header>
                    <v-row>
                      <v-col cols="6">
                        <h5>{{ item.name }}</h5>
                      </v-col>
                      <v-col cols="6">
                        <span dir="ltr" style="float: left">{{
                          item.date
                        }}</span>
                      </v-col>
                    </v-row>
                  </template>
                  <b-card-text>
                    <div v-html="item.message"></div>
                    <br />
                  </b-card-text>
                </b-card>
              </v-col>
              <v-col cols="1"></v-col>
              <v-col cols="1"></v-col>
            </v-row>
          </v-card>
        </b-tab>
        <b-tab title="اقلام سفارش">
          <b-card class="shadow p-3 mb-5 bg-white rounded">
            <template v-slot:header>
              <h6>
                <b-input-group size="md">
                  <b-form-input
                    v-model="filter2"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter2"
                      @click="filter2 = ''"
                      variant="danger"
                      >حذف</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </h6>
            </template>

            <vue-excel-xlsx
              v-if="originalOrderItems.length > 0"
              style="float: left"
              class="mb-3 btn-dark rounded p-2"
              :data="
                originalOrderItems.map((x) => {
                  return {
                    number: parseInt(x.number),
                    length: x.length,
                    diameter: x.diameter,
                    dimensionStandard: x.dimensionStandard,
                    cover: x.cover,
                    material: x.material,
                    description: x.description,
                    details: x.details,
                    customerIndex: x.customerIndex,
                    progress: x.progress,
                  };
                })
              "
              :columns="
                originalOrderFields
                  .map((y) => {
                    return {
                      label: y.label,
                      field: y.key,
                    };
                  })
                  .reverse()
                  .filter((x) => x.field != 'index')
              "
              :file-name="
                factoryOrderInfo.orderCode +
                '_' +
                moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
              "
              :sheet-name="factoryOrderInfo.orderCode"
              >خروجی اکسل</vue-excel-xlsx
            >

            <a
              style="float: left"
              :href="'/printPreview/' + $route.params.id"
              target="_blank"
              class="btn btn-primary mx-1 p-2"
              ><i class="fa fa-print"> &nbsp;</i>نسخه چاپی اقلام سفارش</a
            >

            <b-table
              :busy="tableBusy"
              ref="orderItemsTable"
              responsive
              show-empty
              :filter="filter2"
              :items="originalOrderItems"
              :fields="originalOrderFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
              style="font-family: Tahoma !important"
            >
              <template v-slot:head()="data">
                <div
                  dir="ltr"
                  style="text-align: center; vertical-align: middle"
                >
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div
                  dir="ltr"
                  style="text-align: center; vertical-align: middle"
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>

              <template v-slot:cell(number)="data">
                <div
                  dir="ltr"
                  style="text-align: center; vertical-align: middle"
                >
                  {{ (1 * data.item.number).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(progress)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.item.status ? data.item.status : "بررسی اولیه" }}
                  <br />
                  <div v-html="data.item.notes" v-if="data.item.notes" />
                </div>
              </template>
            </b-table>
            <!-- <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination> -->
            <v-row class="my-2">
              <v-col cols="12"
                >تعداد کل اقلام سفارش:
                {{
                  originalOrderItems.length
                    ? originalOrderItems
                        .map((x) => x.number)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                    : "--"
                }}
                قلم</v-col
              >
            </v-row>

            <vue-excel-xlsx
              v-if="originalOrderItems.length > 0"
              style="float: left"
              class="mb-3 btn-dark rounded p-2"
              :data="
                originalOrderItems.map((x) => {
                  return {
                    number: parseInt(x.number),
                    length: x.length,
                    diameter: x.diameter,
                    dimensionStandard: x.dimensionStandard,
                    cover: x.cover,
                    material: x.material,
                    description: x.description,
                    details: x.details,
                    customerIndex: x.customerIndex,
                    progress: x.progress,
                  };
                })
              "
              :columns="
                originalOrderFields
                  .map((y) => {
                    return {
                      label: y.label,
                      field: y.key,
                    };
                  })
                  .reverse()
                  .filter((x) => x.field != 'index')
              "
              :file-name="
                factoryOrderInfo.orderCode +
                '_' +
                moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
              "
              :sheet-name="factoryOrderInfo.orderCode"
              >خروجی اکسل</vue-excel-xlsx
            >
          </b-card>
        </b-tab>
        <b-tab title="اقلام تولید">
          <b-card class="shadow p-3 mb-5 bg-white rounded">
            <template v-slot:header>
              <v-row>
                <v-col cols="7" class="mt-4">
                  <h4>نام مشتری: {{ factoryOrderInfo.customerName }}</h4>
                  <h5>کد ردیابی: {{ factoryOrderInfo.factoryCode }}</h5>
                  <h5 v-if="factoryOrderInfo.originalRequestId">
                    شماره درخواست مشتری:
                    {{ factoryOrderInfo.originalRequestId }}
                  </h5>
                </v-col>
                <v-col cols="5" class="mt-4">
                  <v-col>
                    <v-row>
                      <v-col>
                        <a
                          :href="'/itemsPrintPreview/' + $route.params.id"
                          target="_blank"
                          class="btn btn-primary m-1 p-2"
                          ><i class="fa fa-print"> &nbsp;</i>نسخه چاپی اقلام
                          تولید</a
                        >
                        <h5 v-if="factoryOrderInfo.factoryCustomerAgentName">
                          نام نماینده مشتری:
                          {{ factoryOrderInfo.factoryCustomerAgentName }}
                        </h5>
                        <h5 v-if="factoryOrderInfo.factoryOtherDescriptions">
                          توضیحات:
                          {{ factoryOrderInfo.factoryOtherDescriptions }}
                        </h5>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-col>
              </v-row>
              <hr />
              <h6>
                <b-input-group size="md">
                  <b-form-input
                    v-model="filter2"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter2"
                      @click="filter2 = ''"
                      variant="danger"
                      >حذف</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </h6>
            </template>
            <b-button
              v-show="
                role == 'Manager' ||
                role == 'factory' ||
                role == 'qc' ||
                role == 'production' ||
                role == 'delivery' ||
                role == 'factoryTechnical'
              "
              variant="primary"
              class="text-white"
              @click="selectAllRows()"
              >انتخاب همه</b-button
            >&nbsp;
            <b-button
              v-show="
                role == 'Manager' ||
                role == 'factory' ||
                role == 'qc' ||
                role == 'production' ||
                role == 'delivery' ||
                role == 'factoryTechnical'
              "
              variant="primary"
              class="text-white"
              @click="selectNone()"
              >انتخاب هیچکدام</b-button
            >&nbsp;
            <b-button
              variant="warning"
              v-show="
                role == 'Manager' ||
                role == 'factory' ||
                role == 'qc' ||
                role == 'production' ||
                role == 'delivery' ||
                role == 'factoryTechnical'
              "
              @click="batchChangeStatus()"
              :disabled="
                selected.reduce((a, b) => Number(a) + Number(b), 0) < 2
              "
              >ویرایش گروهی
              {{ selected.reduce((a, b) => Number(a) + Number(b), 0) }}
              قلم</b-button
            >
            <b-button
              variant="warning"
              style="float: left"
              class="mx-1"
              @click="checkAllInventory()"
              :disabled="tableBusy"
              v-b-tooltip="'بروزرسانی موجودی کل اقلام'"
              ><i class="fa fa-refresh"> </i
            ></b-button>
            <vue-excel-xlsx
              v-if="orderItems.length > 0"
              style="float: left"
              class="mb-3 btn-dark rounded p-2"
              :data="
                orderItems.map((x) => {
                  return {
                    number: parseInt(x.number),
                    length: x.length,
                    diameter: x.diameter,
                    dimensionStandard: x.dimensionStandard,
                    cover: x.cover,
                    material: x.material,
                    description: x.description,
                    details: x.details,
                    customerIndex: x.customerIndex,
                    sum: x.sum,
                    progress: x.progress,
                  };
                })
              "
              :columns="
                orderFields
                  .map((y) => {
                    return {
                      label: y.label,
                      field: y.key,
                    };
                  })
                  .reverse()
                  .filter((x) => x.field != 'index')
              "
              :file-name="
                factoryOrderInfo.orderCode +
                '_' +
                moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
              "
              :sheet-name="factoryOrderInfo.orderCode"
              >خروجی اکسل</vue-excel-xlsx
            >

            <b-table
              :busy="tableBusy"
              ref="orderItemsTable"
              selectable
              select-mode="range"
              selected-variant="primary"
              responsive
              show-empty
              :filter="filter2"
              :items="orderItems"
              :fields="orderFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary table-product"
              style="font-family: Tahoma !important"
              @row-selected="onRowSelected"
              @row-dblclicked="doubleclick"
            >
              <template v-slot:cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                </template>
              </template>
              <template v-slot:head()="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(refresh)="data">
                <b-btn
                  variant="dark"
                  class="mr-2"
                  @click="checkInventory(data.item, data.index)"
                  v-b-tooltip="'بروزرسانی موجودی'"
                  ><i class="fa fa-refresh"> </i
                ></b-btn>
              </template>

              <template v-slot:cell(similarSum)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  <!-- :disabled="!data.value" -->
                  <b-btn
                    variant="secondary"
                    class="mr-2"
                    @click="checkSimilarInventory(data.item, data.index)"
                    v-b-tooltip="'جهت مشاهده جزییات کلیک کنید'"
                  >
                    {{ data.value ? data.value : "-" }}
                  </b-btn>
                </div>
              </template>
              <template v-slot:cell(number)="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  {{ (1 * data.item.number).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(priority)="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  {{
                    data.value
                      ? priorityOptions.filter((x) => x.value == data.value)[0]
                          .text
                      : "--"
                  }}
                </div>
              </template>
              <template v-slot:cell(progress)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  <b-button
                    variant="primary"
                    @click="changeStatus(data.index, data.item)"
                    :disabled="
                      !(
                        role == 'Manager' ||
                        role == 'factory' ||
                        role == 'qc' ||
                        role == 'production' ||
                        role == 'delivery' ||
                        role == 'productsWarehouse' ||
                        role == 'factoryTechnical'
                      )
                    "
                    >{{ data.item.status ? data.item.status : "بررسی اولیه" }}
                    <span v-if="data.item.status == 'در مرحله تولید'"
                      >({{ data.item.productionStatus }})</span
                    >
                  </b-button>
                  <br />
                  <div v-html="data.item.notes" v-if="data.item.notes" />
                </div>
              </template>
            </b-table>
            <!-- <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination> -->
            <v-row class="my-2">
              <v-col cols="12"
                >تعداد کل اقلام تولید:
                {{
                  orderItems.length
                    ? orderItems
                        .map((x) => x.number)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                    : "--"
                }}
                قلم
                <br />
                تعداد کل اقلام سفارش:
                {{
                  originalOrderItems.length
                    ? originalOrderItems
                        .map((x) => x.number)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                    : "--"
                }}
                قلم
              </v-col>
            </v-row>
            <b-button
              v-show="
                role == 'Manager' ||
                role == 'factory' ||
                role == 'qc' ||
                role == 'production' ||
                role == 'delivery' ||
                role == 'factoryTechnical'
              "
              variant="primary"
              class="text-white"
              @click="selectAllRows()"
              >انتخاب همه</b-button
            >&nbsp;
            <b-button
              v-show="
                role == 'Manager' ||
                role == 'factory' ||
                role == 'qc' ||
                role == 'production' ||
                role == 'delivery' ||
                role == 'factoryTechnical'
              "
              variant="primary"
              class="text-white"
              @click="selectNone()"
              >انتخاب هیچکدام</b-button
            >&nbsp;
            <b-button
              variant="warning"
              v-show="
                role == 'Manager' ||
                role == 'factory' ||
                role == 'qc' ||
                role == 'production' ||
                role == 'delivery' ||
                role == 'factoryTechnical'
              "
              @click="batchChangeStatus()"
              :disabled="
                selected.reduce((a, b) => Number(a) + Number(b), 0) < 2
              "
              >ویرایش گروهی
              {{ selected.reduce((a, b) => Number(a) + Number(b), 0) }}
              قلم</b-button
            >
            <vue-excel-xlsx
              v-if="orderItems.length > 0"
              style="float: left"
              class="mb-3 btn-dark rounded p-2"
              :data="
                orderItems.map((x) => {
                  return {
                    number: parseInt(x.number),
                    length: x.length,
                    diameter: x.diameter,
                    dimensionStandard: x.dimensionStandard,
                    cover: x.cover,
                    material: x.material,
                    description: x.description,
                    details: x.details,
                    customerIndex: x.customerIndex,
                    sum: x.sum,
                    progress: x.progress,
                  };
                })
              "
              :columns="
                orderFields
                  .map((y) => {
                    return {
                      label: y.label,
                      field: y.key,
                    };
                  })
                  .reverse()
                  .filter((x) => x.field != 'index')
              "
              :file-name="
                factoryOrderInfo.orderCode +
                '_' +
                moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
              "
              :sheet-name="factoryOrderInfo.orderCode"
              >خروجی اکسل
            </vue-excel-xlsx>
          </b-card>
        </b-tab>
        <b-tab title="پکینگ لیست">
          <b-card class="shadow p-3 mb-5 bg-white rounded">
            <template v-slot:header>
              <a
                v-if="
                  factoryOrderInfo.residual && factoryOrderInfo.residual.length
                "
                :href="'/factory/newPackingList/' + $route.params.id"
                target="_blank"
                class="btn btn-primary m-1 p-2"
                ><i class="fa fa-rocket"> &nbsp;</i>پکینگ لیست جدید</a
              >
              <h3 v-else>
                امکان تعریف پکینگ لیست جدید وجود ندارد. چرا که کلیه اقلام این
                سفارش قبلا در پکینگ‌های زیر ثبت شده است.
              </h3>
            </template>
            <b-tabs
              v-if="
                factoryOrderInfo.packingLists &&
                factoryOrderInfo.packingLists.length
              "
              vertical
              pills
              card
            >
              <b-tab title="کل ارسال‌ها">
                <b-table
                  responsive
                  show-empty
                  :items="factoryOrderInfo.sentItems"
                  :fields="totalPackingListFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table"
                  style="font-family: Tahoma !important"
                  small
                >
                  <template v-slot:head()="data">
                    <div
                      dir="ltr"
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div
                      dir="ltr"
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </b-tab>
              <b-tab
                v-for="packingList in factoryOrderInfo.packingLists"
                :key="packingList.id"
                :title="packingList.packingCode"
              >
                <p>
                  تاریخ صدور: {{ packingList.registerDate }}
                  <b-button
                    @click="deletePackingList(packingList)"
                    variant="danger"
                    style="float: left"
                    >حذف</b-button
                  >
                  <a
                    @click="editPackingList(packingList)"
                    :href="'/factory/editPackingList/' + packingList.id"
                    target="_blank"
                    class="btn purple white--text me-5"
                    style="float: left"
                    >ویرایش</a
                  >
                  <a
                    @click="printPackingList(packingList)"
                    :href="'/printPackingList/' + packingList.id"
                    target="_blank"
                    class="btn btn-primary white--text me-5"
                    style="float: left"
                    >چاپ پکینگ لیست</a
                  >
                </p>
                <p v-if="packingList.description">
                  یادداشت: <span v-html="packingList.description"></span>
                </p>
                <p v-if="packingList.packingDescription">
                  توضیحات پکینگ:
                  <span v-html="packingList.packingDescription"></span>
                </p>
                <p v-if="packingList.address">
                  آدرس تحویل:
                  <span v-html="packingList.address"></span>
                </p>
                <p v-if="packingList.recieverAgent">
                  دریافت کننده:
                  <span v-html="packingList.recieverAgent"></span>
                </p>
                <br />
                <b-table
                  responsive
                  show-empty
                  :items="packingList.list"
                  :fields="
                    packingList.showMapNumber
                      ? packingListFields
                      : packingListFields.filter((x) => x.key != 'mapNumber')
                  "
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table"
                  style="font-family: Tahoma !important"
                  small
                >
                  <template v-slot:head()="data">
                    <div
                      dir="ltr"
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div
                      dir="ltr"
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(palletNo)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{
                        factoryOrderInfo.factoryCode +
                        " - " +
                        packingList.packingCode +
                        " - " +
                        data.value
                      }}
                    </div>
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
            <h4 v-else>
              هنوز پکینگ لیستی برای این سفارش ایجاد نشده است. در صورتی که بخشی
              از محصول آماده و در حال تحویل است، میتوانید با کلیک روی دکمه
              <strong>پکینگ لیست جدید</strong>، لیست جدیدی ایجاد و برای مشتری
              ارسال کنید. <br /><br />
              در صورتی که پکینگ لیست ایجاد شده است، برای همگام سازی اطلاعات صفحه
              را بارگذاری (رفرش) کنید.
            </h4>
          </b-card>
        </b-tab>

        <b-tab
          v-if="role == 'accountant' || role == 'Manager'"
          title="صدور فاکتور"
        >
          <b-card class="shadow p-3 mb-5 bg-white rounded">
            <template v-slot:header>
              <a
                v-if="
                  factoryOrderInfo.remainInvoices &&
                  factoryOrderInfo.remainInvoices.length
                "
                :href="'/accounting/newInvoice/' + $route.params.id"
                target="_blank"
                class="btn btn-primary m-1 p-2"
                ><i class="fa fa-rocket"> &nbsp;</i>فاکتور جدید</a
              >
              <h3 v-else>
                امکان تعریف فاکتور جدید وجود ندارد. چرا که کلیه اقلام این سفارش
                قبلا در فاکتور‌های زیر ثبت شده است.
              </h3>
            </template>
            <b-tabs
              v-if="
                factoryOrderInfo.invoices && factoryOrderInfo.invoices.length
              "
              vertical
              pills
              card
            >
              <b-tab
                v-for="invoice in factoryOrderInfo.invoices"
                :key="invoice.id"
                :title="invoice.invoiceCode"
              >
                <p>
                  تاریخ صدور: {{ invoice.registerDate }}
                  <b-button
                    @click="deleteInvoice(invoice)"
                    variant="danger"
                    style="float: left"
                    >حذف</b-button
                  >
                  <b-button
                    @click="editInvoice(invoice)"
                    class="purple white--text me-5"
                    style="float: left"
                    >ویرایش</b-button
                  >
                  <a
                    @click="printInvoice(invoice)"
                    :href="'/printInvoice/' + invoice.id"
                    target="_blank"
                    class="btn btn-primary white--text me-5"
                    style="float: left"
                    >چاپ فاکتور</a
                  >
                </p>
                <p v-if="invoice.description">
                  یادداشت: <span v-html="invoice.description"></span>
                </p>
                <p v-if="invoice.packingDescription">
                  توضیحات پکینگ:
                  <span v-html="invoice.packingDescription"></span>
                </p>
                <p v-if="invoice.address">
                  آدرس تحویل:
                  <span v-html="invoice.address"></span>
                </p>
                <p v-if="invoice.recieverAgent">
                  دریافت کننده:
                  <span v-html="invoice.recieverAgent"></span>
                </p>
                <br />
                <b-table
                  responsive
                  show-empty
                  :items="invoice.list"
                  :fields="invoiceFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table"
                  style="font-family: Tahoma !important"
                  small
                >
                  <template v-slot:head()="data">
                    <div
                      dir="ltr"
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div
                      dir="ltr"
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(perPrice)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(discount)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(discountPrice)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(tax)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(payPrice)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template #custom-foot="data">
                    <b-tr>
                      <b-th colspan="6">جمع کل</b-th>
                      <b-th colspan="2">{{
                        data.items
                          .map((inv) => inv.price)
                          .reduce((a, b) => a + b)
                          .toLocaleString()
                      }}</b-th>
                      <b-th class="text-center">{{
                        data.items
                          .map((inv) => inv.discountPrice)
                          .reduce((a, b) => a + b)
                          .toLocaleString()
                      }}</b-th>
                      <b-th class="text-center">{{
                        data.items
                          .map((inv) => inv.tax)
                          .reduce((a, b) => a + b)
                          .toLocaleString()
                      }}</b-th>
                      <b-th class="text-center">{{
                        data.items
                          .map((inv) => inv.payPrice)
                          .reduce((a, b) => a + b)
                          .toLocaleString()
                      }}</b-th>
                    </b-tr>
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
            <h4 v-else>
              هنوز فاکتوری برای این سفارش ایجاد نشده است. در صورتی که بخشی از
              محصول آماده و در حال تحویل است، میتوانید با کلیک روی دکمه
              <strong> فاکتور جدید</strong>، لیست جدیدی ایجاد و برای مشتری ارسال
              کنید. <br /><br />
              در صورتی که فاکتور ایجاد شده است، برای همگام سازی اطلاعات صفحه را
              بارگذاری (رفرش) کنید.
            </h4>
          </b-card>
        </b-tab>
      </b-tabs>
    </v-col>

    <v-dialog v-model="changeOrderStatusDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>تغییر وضعیت کل سفارش</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <h5>وضعیت قبلی: {{ factoryOrderInfo.factoryStatus }}</h5>
            <v-select
              v-model="factoryInfoTemp.factoryStatus"
              :items="orderProgressOptions"
              label="وضعیت جدید"
              class="mt-3"
              outlined
              dense
            ></v-select>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="productNoteModal"
                :editor="editor"
                :config="editorConfig"
              />
            </div>
            <b-form-checkbox v-model="editAllItems"
              >میخواهم کلیه اقلام سفارش نیز با این وضعیت بروزرسانی
              شوند</b-form-checkbox
            >
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="
              changeOrderStatusDialog = false;
              productNoteModal = '';
            "
          >
            لغو
          </v-btn>
          <v-btn @click="submitOrderStatus()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newNoteDialog" max-width="600px">
      <v-card>
        <v-card-title dark>
          <h4>یادداشت</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <p>
              کاربر گرامی لطفا یادداشت‌های عمومی خود را در این بخش وارد نمایید
            </p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="contentNoteModal"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="newNoteDialog = false">
            لغو
          </v-btn>
          <v-btn @click="sendNote()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="changeStatusDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>تغییر وضعیت محصول</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-select
              v-model="selectedProgress"
              :items="progressOptions"
              label="وضعیت جدید"
              class="mt-3"
              outlined
              dense
              :disabled="
                !(
                  role == 'Manager' ||
                  role == 'factory' ||
                  role == 'qc' ||
                  role == 'production' ||
                  role == 'delivery' ||
                  role == 'productsWarehouse' ||
                  role == 'factoryTechnical'
                )
              "
            ></v-select>
            <v-select
              v-if="selectedProgress == 'در مرحله تولید'"
              v-model="selectedProductionStatus"
              :items="productionStatusOptions"
              label="وضعیت تولید جدید"
              class="mt-3"
              outlined
              dense
              :disabled="
                !(
                  role == 'Manager' ||
                  role == 'factory' ||
                  role == 'qc' ||
                  role == 'production' ||
                  role == 'delivery' ||
                  role == 'factoryTechnical'
                )
              "
            ></v-select>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="productNoteModal"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="changeStatusDialog = false"
          >
            لغو
          </v-btn>
          <v-btn @click="submitProduct()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="groupChangeStatusDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>تغییر وضعیت گروهی محصولات</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-select
              v-model="selectedProgress"
              :items="progressOptions"
              label="وضعیت جدید"
              class="mt-3"
              outlined
              dense
            ></v-select>
            <v-select
              v-if="selectedProgress == 'در مرحله تولید'"
              v-model="selectedProductionStatus"
              :items="productionStatusOptions"
              label="وضعیت تولید جدید"
              class="mt-3"
              outlined
              dense
            ></v-select>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="productNoteModal"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="groupChangeStatusDialog = false"
          >
            لغو
          </v-btn>
          <v-btn @click="submitProductsGroup()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editOrderInfoModal" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>ویرایش سفارش</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3 p-4">
            <p>میتوانید المان‌های زیر را از فرم سفارش ساخت ویرایش کنید.</p>
            <!-- <b-form-group label="تاریخ">
              <date-picker
                placeholder="تاریخ"
                v-model="factoryInfoTemp.factoryDate"
                :editable="true"
              ></date-picker>
            </b-form-group> -->
            <v-text-field
              outlined
              dense
              label="نام مشتری"
              v-model="factoryInfoTemp.customerName"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="شماره سفارش"
              v-model="factoryInfoTemp.orderCode"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="تعداد اقلام"
              v-model="factoryInfoTemp.factoryCount"
            ></v-text-field>
            <v-select
              outlined
              dense
              label="نوع بسته بندی"
              :items="packageOptions"
              v-model="factoryInfoTemp.factoryPackage"
            ></v-select>
            <v-text-field
              outlined
              dense
              label="نوع پوشش"
              v-model="factoryInfoTemp.factoryCoating"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="زمان تحویل"
              v-model="factoryInfoTemp.factoryDeliveryDuration"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="محل تحویل"
              v-model="factoryInfoTemp.factoryDeliveryLocation"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="هزینه حمل"
              v-model="factoryInfoTemp.factoryDeliveryCost"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="نام نماینده مشتری"
              v-model="factoryInfoTemp.factoryCustomerAgentName"
            ></v-text-field>
            <v-select
              outlined
              dense
              label="بازرسی"
              :items="inspectionOptions"
              v-model="factoryInfoTemp.factoryInspection"
            ></v-select>
            <v-text-field
              outlined
              dense
              label="کیلویی"
              v-model="factoryInfoTemp.factoryWeight"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="شماره تلفن"
              v-model="factoryInfoTemp.factoryPhone"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="سایر توضیحات"
              v-model="factoryInfoTemp.factoryOtherDescriptions"
            ></v-textarea>
            <v-text-field
              outlined
              dense
              label="آدرس ارسال"
              v-model="factoryInfoTemp.factoryDeliveryAddress"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="editOrderInfoModal = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="editOrderFactory()"> ویرایش </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editOrderItem" max-width="600px">
      <v-card>
        <v-card-title class="mb-3" style="padding-top: 38px">
          <h4>ویرایش {{ selectedProduct.description }}</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              outlined
              dense
              label="شرح کالا"
              v-model="selectedProduct.description"
            />

            <v-text-field
              outlined
              dense
              label="شماره نقشه"
              v-model="selectedProduct.mapNumber"
            />

            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="selectedProduct.material"
            />

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="selectedProduct.coating"
            />

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="selectedProduct.dimensionStandard"
            />

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="selectedProduct.diameter"
            />

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="selectedProduct.length"
            />

            <v-text-field
              outlined
              dense
              label="تعداد"
              v-model="selectedProduct.number"
            />

            <v-select
              v-model="selectedProduct.newStatus"
              :items="progressOptions"
              label="وضعیت جدید"
              class="mt-3"
              outlined
              dense
            ></v-select>
            <v-select
              v-if="selectedProduct.newStatus == 'در مرحله تولید'"
              v-model="selectedProduct.productionStatus"
              :items="productionStatusOptions"
              label="وضعیت تولید جدید"
              class="mt-3"
              outlined
              dense
            ></v-select>
            <v-select
              outlined
              dense
              label="اولویت تولید"
              :items="priorityOptions"
              v-model="selectedProduct.priority"
            ></v-select>
            <v-select
              outlined
              dense
              label="نوع کالا"
              :items="typeOptions"
              v-model="selectedProduct.type"
            ></v-select>

            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="selectedProduct.orderItemNote"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="editOrderItem = false">
            لغو
          </v-btn>
          <v-btn @click="editOrderItemId()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmPackingListDelete" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>حذف پکینگ لیست</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <h5>شما در حال حذف پکینگ لیست با مشخصات زیر هستید:</h5>
            <p>تاریخ صدور: {{ selectedPackingList.registerDate }}</p>
            <p v-if="selectedPackingList.description">
              یادداشت: <span v-html="selectedPackingList.description"></span>
            </p>
            <p v-if="selectedPackingList.packingDescription">
              توضیحات پکینگ:
              <span v-html="selectedPackingList.packingDescription"></span>
            </p>
            <p v-if="selectedPackingList.address">
              آدرس تحویل:
              <span v-html="selectedPackingList.address"></span>
            </p>
            <p v-if="selectedPackingList.recieverAgent">
              دریافت کننده:
              <span v-html="selectedPackingList.recieverAgent"></span>
            </p>
            <br />
            <b-table
              responsive
              show-empty
              :items="selectedPackingList.list"
              :fields="packingListFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table"
              style="font-family: Tahoma !important"
              small
            >
              <template v-slot:head()="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div
                  dir="ltr"
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma !important;
                  "
                >
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="primary"
            @click="
              confirmPackingListDelete = false;
              selectedPackingList = {};
            "
          >
            لغو
          </v-btn>
          <v-btn @click="doDeletePackingList()" color="red" class="white--text">
            مطمئن هستم
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteInvoiceDialog" width="500">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span> حذف فاکتور </span>
          <span @click="deleteInvoiceDialog = false" class="white--text"
            ><v-icon class="white--text pointer">mdi-close</v-icon></span
          >
        </v-card-title>
        <v-card-text class="mt-4">
          <div>آیا از حذف این فاکتور اطمینان دارید؟</div>
          <div class="mt-4 d-flex justify-end">
            <v-btn class="green white--text" @click="doDeleteInvoice()"
              >بله</v-btn
            >
            <v-btn
              class="red white--text ms-3"
              @click="deleteInvoiceDialog = false"
              >خیر</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div id="Form" v-show="false">
      <table class="orderInfoTable" border="1px" style="width: 100%">
        <tr>
          <th class="p-1">کد ردیابی</th>
          <td class="p-1">{{ factoryOrderInfo.factoryCode }}</td>
        </tr>
        <tr>
          <th class="p-1">نام مشتری</th>
          <td class="p-1">{{ factoryOrderInfo.customerName }}</td>
        </tr>
        <tr>
          <th class="p-1">شماره درخواست مشتری</th>
          <td class="p-1">
            {{ factoryOrderInfo.originalRequestId }}
          </td>
        </tr>
        <tr>
          <th class="p-1">تعداد اقلام سفارش</th>
          <td class="p-1">{{ factoryOrderInfo.factoryCount }}</td>
        </tr>
        <tr>
          <th class="p-1">بسته‌بندی</th>
          <td class="p-1">{{ factoryOrderInfo.factoryPackage }}</td>
        </tr>
        <tr>
          <th class="p-1">پوشش</th>
          <td class="p-1">{{ factoryOrderInfo.factoryCoating }}</td>
        </tr>
        <tr>
          <th class="p-1">زمان تحویل</th>
          <td class="p-1">
            {{ factoryOrderInfo.factoryDeliveryDuration }}
          </td>
        </tr>
        <tr>
          <th class="p-1">محل تحویل</th>
          <td class="p-1">
            {{ factoryOrderInfo.factoryDeliveryLocation }}
          </td>
        </tr>
        <tr>
          <th class="p-1">هزینه حمل</th>
          <td class="p-1">
            {{ factoryOrderInfo.factoryDeliveryCost }}
          </td>
        </tr>
        <tr>
          <th class="p-1">نام نماینده مشتری</th>
          <td class="p-1">
            {{ factoryOrderInfo.factoryCustomerAgentName }}
          </td>
        </tr>
        <tr>
          <th class="p-1">بازرسی</th>
          <td class="p-1">
            {{ factoryOrderInfo.factoryInspection }}
          </td>
        </tr>
        <tr>
          <th class="p-1">وزن</th>
          <td class="p-1">{{ factoryOrderInfo.factoryWeight }}</td>
        </tr>
        <tr>
          <th class="p-1">شماره تماس مشتری</th>
          <td class="p-1">{{ factoryOrderInfo.factoryPhone }}</td>
        </tr>
        <tr>
          <th class="p-1">سایر توضیحات</th>
          <td class="p-1">
            {{ factoryOrderInfo.factoryOtherDescriptions }}
          </td>
        </tr>
        <tr>
          <th class="p-1">آدرس تحویل</th>
          <td class="p-1">
            {{ factoryOrderInfo.factoryDeliveryAddress }}
          </td>
        </tr>
        <tr>
          <th class="p-1">تاریخ ابلاغ</th>
          <td class="p-1">{{ factoryOrderInfo.factoryDate }}</td>
        </tr>
      </table>
    </div>
  </v-row>
</template>
<script>
import Axios from "axios";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

function ConvertToCSV(myFields, objArray) {
  console.log(myFields);

  var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  var str = "";
  str = myFields.map((x) => x.label).join('","') + "\r\n";
  // '"قیمت واحد","تعداد","طول","قطر","استاندارد ابعاد","پوشش","متریال","شرح کالا"\r\n'
  for (var i = 0; i < array.length; i++) {
    var line = "";
    for (var index in array[i]) {
      if (line != "") line += ",";

      line += '"' + array[i][index] + '"';
    }
    str += line + "\r\n";
  }
  return str;
}

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: "fa",
        contentsLangDirection: "rtl",
      },
      deleteInvoiceDialog: false,
      guide: false,
      tableBusy: false,
      subject: "",
      contentCustomerModal: "",
      customerName: "",
      moment: moment,
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      selectedProduct: {},
      author: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      filter: null,
      filter2: null,
      taskTypeModal: "",
      ticketName: "",
      ticketCode: "",
      progress: "",
      doneProgress: 0,
      max: 100,
      timeProgress: 0,
      startDate: "",
      dueDate: "",
      taskDescription: "",
      time: "",
      notes: "",
      status: "",
      packageOptions: [
        {
          value: "کارتن یا پالت چوبی",
          text: "کارتن یا پالت چوبی",
        },
        {
          value: "پالت فلزی",
          text: "پالت فلزی",
        },
        {
          value: "صندوق چوبی",
          text: "صندوق چوبی",
        },
        {
          value: "سایر",
          text: "سایر",
        },
      ],
      inspectionOptions: [
        {
          value: "دارد",
          text: "دارد",
        },
        {
          value: "ندارد",
          text: "ندارد",
        },
      ],
      progressOptions: [
        { value: "بررسی اولیه", text: "بررسی اولیه" },
        { value: "توقف موقت تولید", text: "توقف موقت تولید" },
        {
          value: "در مرحله تامین مواد اولیه",
          text: "در مرحله تامین مواد اولیه",
        },
        { value: "در مرحله تولید", text: "در مرحله تولید" },
        { value: "در مرحله تامین", text: "در مرحله تامین" },
        { value: "موجود در انبار", text: "موجود در انبار" },
        { value: "در مرحله پوشش کاری", text: "در مرحله پوشش کاری" },
        { value: "اتمام تولید", text: "اتمام تولید" },
        { value: "در مرحله ارسال", text: "در مرحله ارسال" },
        { value: "در مرحله بسته بندی", text: "در مرحله بسته بندی" },
        { value: "لغو سفارش", text: "لغو سفارش" },
        { value: "تحویل نهایی", text: "تحویل نهایی" },
        { value: "خرید خدمت تولید", text: "خرید خدمت تولید" },
        {
          value: "خرید خدمت پوشش گالوانیزه گرم",
          text: "خرید خدمت پوشش گالوانیزه گرم",
        },
        { value: "خرید خدمت پوشش تفلون", text: "خرید خدمت پوشش تفلون" },
        { value: "خرید خدمت پوشش سرامیک", text: "خرید خدمت پوشش سرامیک" },
        { value: "خرید خدمت پوشش زایلون", text: "خرید خدمت پوشش زایلون" },
        {
          value: "خرید خدمت پوشش گالوانیزه سرد",
          text: "خرید خدمت پوشش گالوانیزه سرد",
        },
        { value: "خرید خدمت پوشش داک", text: "خرید خدمت پوشش داک" },
        { value: "خرید خدمت خدمات فورجینگ", text: "خرید خدمت خدمات فورجینگ" },
        { value: "خرید خدمت سختکاری", text: "خرید خدمت سختکاری" },
        { value: "در انتظار صدور نقشه فنی", text: "در انتظار صدور نقشه فنی" },
        {
          value: "در انتظار تایید نقشه فنی",
          text: "در انتظار تایید نقشه فنی",
        },
        { value: "در انتظار خرید خدمت", text: "در انتظار خرید خدمت" },
      ],
      productionStatusOptions: [
        { value: "برش", text: "برش" },
        { value: "اکسترود", text: "اکسترود" },
        { value: "فورج", text: "فورج" },
        { value: "ماشینکاری", text: "ماشینکاری" },
        { value: "مته مرغک زنی", text: "مته مرغک زنی" },
        { value: "شیارزنی", text: "شیارزنی" },
        { value: "فرزکاری", text: "فرزکاری" },
        { value: "پرداخت", text: "پرداخت" },
        { value: "آج زنی", text: "آج زنی" },
        { value: "مارک زنی", text: "مارک زنی" },
        { value: "دنده زنی", text: "دنده زنی" },
        { value: "عملیات حرارتی", text: "عملیات حرارتی" },
        { value: "سوراخکاری", text: "سوراخکاری" },
        { value: "کف تراشی", text: "کف تراشی" },
        { value: "پخ زنی", text: "پخ زنی" },
        { value: "داخل تراشی", text: "داخل تراشی" },
        { value: "قلاویز زنی", text: "قلاویز زنی" },
      ],
      orderProgressOptions: [
        { value: "سفارش جدید", text: "سفارش جدید" },
        { value: "در مرحله تولید", text: "در مرحله تولید" },
        { value: "در مرحله پوشش کاری", text: "در مرحله پوشش کاری" },
        { value: "در مرحله بسته بندی", text: "در مرحله بسته بندی" },
        { value: "در مرحله ارسال", text: "در مرحله ارسال" },
        { value: "تحویل و ارسال شد", text: "تحویل و ارسال شد" },
        { value: "توقف تولید", text: "توقف تولید" },
      ],
      statusNoteModal: "",
      statusId: "",
      newStatusId: "",
      priority: "",
      fields: [
        { key: "index", label: "#" },
        { key: "date", label: "تاریخ آپلود" },
        { key: "name", label: "نام فایل" },
        // { key: "subject", label: "توضیحات" },
        { key: "uploaderName", label: "فرد بارگذاری کننده" },
        { key: "actions", label: "عملیات" },
      ],
      priorityOptions: [
        {
          value: "low",
          text: "پایین",
        },
        {
          value: "normal",
          text: "معمولی",
        },
        {
          value: "high",
          text: "بالا",
        },
        {
          value: "urgent",
          text: "اورژانسی",
        },
      ],
      typeOptions: [
        { value: "پیچ", text: "پیچ" },
        { value: "مهره", text: "مهره" },
        { value: "واشر", text: "واشر" },
        { value: "دست", text: "دست" },
        { value: "سایر", text: "سایر" },
      ],
      orderFields: [
        { key: "selected", label: "" },
        { key: "type", label: "نوع محصول" },
        { key: "priority", label: "اولویت تولید" },
        { key: "mapNumber", label: "شماره نقشه" },
        { key: "progress", label: "وضعیت محصول" },
        { key: "itemCode", label: "شماره سفارش" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "coating", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "sum", label: "موجودی انبار" },
        { key: "similarSum", label: "موجودی انبار کالاهای مشابه" },
        { key: "refresh", label: "بازیابی" },
        { key: "index", label: "ردیف" },
      ],
      similarWarehouseItemsFields: [
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "coating", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "stocks", label: "موجودی انبار" },
        { key: "index", label: "ردیف" },
      ],
      originalOrderFields: [
        { key: "itemCode", label: "شماره سفارش" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: " ردیف مشتری" },
        { key: "index", label: "ردیف" },
      ],
      orderItems: [],
      originalOrderItems: [],
      formTemplate: "",
      hasCustomerIndex: false,
      hasSizeStandard: true,
      ticketName: "",
      taskStatus: "",
      Today: "",
      startDate: "",
      dueDate: "",
      items: [],
      history: [],
      assignee: "",
      assigneeId: 0,
      isBusy: false,
      shamsiStartDate: "",
      shamsiDueDate: "",
      contentNoteModal: "",
      contentAssigneeModal: "",
      options: [
        { value: "sms", text: "اس‌ام‌اس" },
        { value: "system", text: "سیستمی" },
        { value: "letter", text: "نامه رسمی" },
      ],
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
      currency: "",
      selected: "",
      role: "",
      currentUserId: "",
      totalOrder: {},
      discount: 0,
      letterId: "",
      customerPerson: "",
      factoryInfo: {},
      factoryInfoTemp: {},
      productNoteModal: "",
      selectedIndex: "",
      selectedProgress: "",
      selectedProductionStatus: "",
      selected: [],
      newNoteDialog: false,
      changeOrderStatusDialog: false,
      editAllItems: false,
      changeStatusDialog: false,
      groupChangeStatusDialog: false,
      editOrderInfoModal: false,
      editOrderItem: false,
      factoryOrderInfo: {},
      factoryOrderFiles: [],
      selectedRow: [],
      selectedRowStatus: "",
      similarWarehouseItems: [],
      similarWarehouseItemsDialog: false,
      packingListFields: [
        { key: "operation", label: "عملیات" },
        { key: "packingCode", label: "شماره پالت" },
        { key: "boxNo", label: "شماره جعبه" },
        { key: "netWeight", label: "وزن خالص" },
        { key: "grossWeight", label: "وزن غیرخالص" },
        { key: "remarks", label: "نکات تکمیلی" },
        { key: "packingDescription", label: "توضیحات بسته‌بندی" },
        { key: "packingType", label: "نوع بسته‌بندی" },
        { key: "boxCount", label: "تعداد جعبه" },
        { key: "qty", label: "تعداد" },
        { key: "previousQTY", label: "تعداد قبلی" },
        { key: "number", label: "تعداد کل" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "coating", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "mapNumber", label: "شماره نقشه" },
        { key: "customerIndex", label: " ردیف مشتری" },
        { key: "index", label: "ردیف" },
      ],
      totalPackingListFields: [
        { key: "totalSend", label: "تعداد ارسال شده" },
        { key: "number", label: "تعداد کل" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "coating", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "ردیف" },
      ],
      invoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "کد کالا" },
        { key: "description", label: "شرح کالا یا خدمات" },
        { key: "number", label: "تعداد/مقدار" },
        { key: "measurementUnit", label: "واحد اندازه گیری" },
        { key: "perPrice", label: "مبلغ واحد" },
        { key: "price", label: "مبلغ کل" },
        { key: "discount", label: "مبلغ تخفیف" },
        { key: "discountPrice", label: "مبلغ کل پس از تخفیف (ریال)" },
        { key: "tax", label: "جمع مالیات و عوارض (ریال)" },
        {
          key: "payPrice",
          label: "مبلغ نهایی (ریال)",
        },
      ],
      selectedPackingList: {},
      confirmPackingListDelete: false,
    };
  },
  components: {
    // VueSlideBar
    VueSlider,
    // VueHorizontalTimeline,
    datePicker: VuePersianDatetimePicker,
    CKEditor,
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    checkAllInventory() {
      this.vLoading = true;
      var myCount = 0;
      this.orderItems.forEach((item) => {
        Axios.post(
          this.baseUrl + "/ppkpms/factory/order/orderItemWarehouseStocks",
          {
            orderItemId: item.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              item.inventory = res.data.sum;
              item.similarsum = res.data.similarSum;
              myCount++;
              if (myCount == this.orderItems.length) this.vLoading = false;
            } else {
              myCount++;
              if (myCount == this.orderItems.length) this.vLoading = false;
              this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            myCount++;
            if (myCount == this.orderItems.length) this.vLoading = false;
            this.toast("خطا: " + err.response.data, "error");
          });
      });
    },
    checkSimilarInventory(item, index) {
      this.selectedProduct = item;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/orderItem/rawWarehouseStocks",
        {
          orderItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.similarWarehouseItems = res.data;
            this.similarWarehouseItemsDialog = true;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    checkInventory(item, index) {
      this.tableBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/orderItemWarehouseStocks",
        {
          orderItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            item.inventory = res.data.sum;
            item.similarsum = res.data.similarSum;
            this.tableBusy = false;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    selectAllRows() {
      this.$refs.orderItemsTable.selectAllRows();
    },
    selectNone() {
      this.$refs.orderItemsTable.clearSelected();
    },
    onRowSelected(items) {
      (this.selectedRow.length = 0),
        items.forEach((element) => {
          this.selectedRow.push(element.id);
        });
      this.selected = this.orderItems.map((x, index) =>
        this.$refs.orderItemsTable.isRowSelected(index)
      );
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    getTaskInfo() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/getInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.vLoading = false;
            this.factoryOrderInfo = res.data;
            this.invocies = this.factoryOrderInfo.invoices;
            this.originalOrderItems = this.factoryOrderInfo.orderItems
              ? JSON.parse(this.factoryOrderInfo.orderItems)
              : "";
            if (!res.data.hasCustomerIndex) {
              this.originalOrderFields = this.originalOrderFields.filter(
                (x) => x.key != "customerIndex"
              );
            }
            // this.factoryInfo = JSON.parse(this.factoryOrderInfo.factoryInfo);
            this.orderItems = this.factoryOrderInfo.items;
            this.orderItems.forEach((service) => {
              if (service.status == "توقف موقت تولید") {
                service._rowVariant = "danger";
              }
            });
            // this.orderItems.forEach((item) => {
            //   item.inventory = "?";
            // });
            // this.checkAllInventory();
            this.history = this.factoryOrderInfo.factoryHistory;
            this.factoryOrderFiles = this.factoryOrderInfo.factoryFiles
              ? JSON.parse(this.factoryOrderInfo.factoryFiles)
              : "";
            this.totalRows = this.orderItems.length;

            if (this.factoryOrderInfo.packingLists.length) {
              this.factoryOrderInfo.packingLists.forEach((packingList) => {
                var myList;
                var myMapNumberCount;
                myList = packingList.list.map((x) =>
                  x.mapNumber ? x.mapNumber : ""
                );
                myMapNumberCount = myList.reduce((a, b) => a.concat(b), "");
                packingList.showMapNumber = Boolean(myMapNumberCount);
              });
            }
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.vLoading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    deletePackingList(item) {
      this.selectedPackingList = item;
      this.confirmPackingListDelete = true;
    },
    deleteInvoice(item) {
      this.selectedPackingList = item;
      this.deleteInvoiceDialog = true;
    },
    editPackingList(item) {
      this.$router.push("/factory/editPackingList/" + item.id);
    },
    editInvoice(item) {
      this.$router.push("/accounting/editInvoice/" + item.id);
    },
    printPackingList(item) {
      this.$router.push("/printPackingList/" + item.id);
    },
    printInvoice(item) {
      this.$router.push("/printInvoice/" + item.id);
    },

    doDeletePackingList() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/packingList/delete",
        {
          packingListId: this.selectedPackingList.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.confirmPackingListDelete = false;
            this.getTaskInfo();
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    doDeleteInvoice() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/accounting/invoice/delete",
        {
          invoiceId: this.selectedPackingList.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.deleteInvoiceDialog = false;
            this.getTaskInfo();
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },

    editOrderFactory() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/editOrder",
        {
          orderId: this.$route.params.id,
          factoryStatus: this.factoryOrderInfo.factoryStatus,
          factoryCount: this.factoryInfoTemp.factoryCount,
          factoryCustomerAgentName:
            this.factoryInfoTemp.factoryCustomerAgentName,
          // factoryDate: this.factoryInfoTemp.factoryDate,
          factoryDeliveryAddress: this.factoryInfoTemp.factoryDeliveryAddress,
          factoryDeliveryCost: this.factoryInfoTemp.factoryDeliveryCost,
          factoryDeliveryDuration: this.factoryInfoTemp.factoryDeliveryDuration,
          factoryDeliveryLocation: this.factoryInfoTemp.factoryDeliveryLocation,
          factoryInspection: this.factoryInfoTemp.factoryInspection,
          factoryOtherDescriptions:
            this.factoryInfoTemp.factoryOtherDescriptions,
          factoryPackage: this.factoryInfoTemp.factoryPackage,
          factoryPhone: this.factoryInfoTemp.factoryPhone,
          factoryWeight: this.factoryInfoTemp.factoryWeight,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.editOrderInfoModal = false;
            this.factoryInfoTemp = {};
            this.getTaskInfo();
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    showModalNote() {
      this.newNoteDialog = true;
    },
    closeModalNotes() {
      this.$refs["modalNote"].hide();
    },
    submitModalNotes() {
      // Axios.put(
      //   this.baseUrl + "/issues/" + this.$route.params.id + ".json",
      //   {
      //     issue: {
      //       notes: this.contentNoteModal
      //     }
      //   },
      //   {
      //     headers: {
      //       "X-Redmine-API-Key": window.localStorage.api_key
      //     }
      //   }
      // )
      //   .then(
      //     alert("یادداشت با موفقیت افزوده شد"),
      //     (this.contentNoteModal = ""),
      //     this.closeModalNotes(),
      //     this.getTaskInfo()
      //   )
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    showModalProgress() {
      this.$refs["modalProgress"].show();
    },
    closeModalProgress() {
      this.statusNoteModal = "";
      this.newStatusId = this.statusId;
      this.$refs["modalProgress"].hide();
    },
    showModalProduct() {
      this.$refs["modalProduct"].show();
    },
    closeModalProduct() {
      this.selectedIndex = "";
      this.selectedProgress = "";
      this.productNoteModal = "";
      this.$refs["modalProduct"].hide();
    },
    closeModalProductBatch() {
      this.$refs["modalProductBatch"].hide();
    },
    submitModalProgress() {
      // Axios.put(
      //   this.baseUrl + "/issues/" + this.$route.params.id + ".json",
      //   {
      //     issue: {
      //       notes: this.statusNoteModal,
      //       custom_fields: [{ id: 162, value: this.newStatusId }]
      //     }
      //   },
      //   {
      //     headers: {
      //       "X-Redmine-API-Key": window.localStorage.api_key
      //     }
      //   }
      // )
      //   .then(
      //     alert("وضعیت به روز شد."),
      //     this.closeModalProgress(),
      //     this.getTaskInfo()
      //   )
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    editOrderItemId() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/editOrderItemId",
        {
          orderItemId: this.selectedProduct.id,
          status: this.selectedProduct.newStatus,
          productionStatus: this.selectedProduct.productionStatus,
          notes: this.selectedProduct.orderItemNote,
          description: this.selectedProduct.description,
          material: this.selectedProduct.material,
          coating: this.selectedProduct.coating,
          dimensionStandard: this.selectedProduct.dimensionStandard,
          diameter: this.selectedProduct.diameter,
          length: this.selectedProduct.length,
          number: this.selectedProduct.number,
          type: this.selectedProduct.type,
          priority: this.selectedProduct.priority,
          mapNumber: this.selectedProduct.mapNumber,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.editOrderItem = false;
            this.getTaskInfo();
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    submitProductsGroup() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/editOrderItems",
        {
          ids: this.selectedRow.length
            ? JSON.stringify(this.selectedRow)
            : this.selectedRowStatus,
          status: this.selectedProgress,
          productionStatus: this.selectedProductionStatus,
          notes: this.productNoteModal,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.groupChangeStatusDialog = false;
            this.getTaskInfo();
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    submitProduct() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/editOrderItemId",
        {
          orderItemId: this.selectedRowStatus,
          status: this.selectedProgress,
          productionStatus: this.selectedProductionStatus,
          notes: this.productNoteModal,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.changeStatusDialog = false;
            this.getTaskInfo();
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    submitOrderStatus() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/editStatus",
        {
          orderId: this.$route.params.id,
          factoryStatus: this.factoryInfoTemp.factoryStatus,
          updateAllItems: this.editAllItems,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.changeOrderStatusDialog = false;
            this.factoryInfoTemp = {};
            this.productNoteModal = "";
            this.getTaskInfo();
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    submitEdit() {
      if (
        new Date(
          moment(this.shamsiStartDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
        ) >
        new Date(
          moment(this.shamsiDueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
        )
      ) {
        alert("تاریخ شروع از تاریخ پایان بزرگتر است");
      } else {
        this.startDate = new Date(
          moment(this.shamsiStartDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
        );
        this.dueDate = new Date(
          moment(this.shamsiDueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
        );

        this.timeProgress = Math.floor(
          ((this.Today - this.startDate) / (this.dueDate - this.startDate)) *
            100
        );
        if (this.timeProgress <= 0) {
          this.timeProgress = 0;
        } else if (this.timeProgress >= 100) {
          this.timeProgress = 100;
        }
      }
    },
    delFile(item) {
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/removeFile",
        {
          orderId: this.$route.params.id,
          fileName: item.name,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("فایل با موفقیت از پرونده حذف گردید", "success");
            this.getTaskInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    changeStatus(index, item) {
      this.selectedRowStatus = item.id;
      this.selectedIndex = index;
      this.selectedProgress = this.orderItems[index].status;
      this.selectedProductionStatus = this.orderItems[index].productionStatus;
      this.productNoteModal = this.orderItems[index].notes;
      this.changeStatusDialog = true;
    },
    batchChangeStatus() {
      this.selectedProgress = "";
      this.selectedProductionStatus = "";
      this.productNoteModal = "";
      this.groupChangeStatusDialog = true;
    },
    factoryModal() {
      this.factoryInfoTemp = JSON.parse(JSON.stringify(this.factoryOrderInfo));
      this.editOrderInfoModal = true;
    },
    changeOrderStatusDialogModal() {
      this.factoryInfoTemp = JSON.parse(JSON.stringify(this.factoryOrderInfo));
      this.changeOrderStatusDialog = true;
    },
    submitFactoryModal() {
      // Axios.put(
      //   this.baseUrl + "/issues/" + this.$route.params.id + ".json",
      //   {
      //     issue: {
      //       notes: "فرم سفارش ساخت به روز شد",
      //       custom_fields: [
      //         {
      //           id: 195,
      //           value: JSON.stringify(this.factoryInfoTemp)
      //         }
      //       ]
      //     }
      //   },
      //   {
      //     headers: {
      //       "X-Redmine-API-Key": window.localStorage.api_key
      //     }
      //   }
      // )
      //   .then(res => {
      //
      //       this.closeFactoryModal(),
      //       setTimeout(() => {
      //         this.getTaskInfo();
      //       }, 500);
      //   })
      //   .catch(err2 => {
      //     console.log("ERR2: " + err);
      //   });
    },
    doubleclick(item) {
      if (
        this.role == "Manager" ||
        this.role == "factory" ||
        this.role == "factoryTechnical"
      ) {
        // alert(JSON.stringify(index))
        // alert(this.selected.indexOf(true))
        this.selectedProduct = item;
        this.editOrderItem = true;
      }
    },
    closeProductEdit() {
      this.selectedProduct = {};
      this.$refs["productEdit"].hide();
    },
    upload(file) {
      if (!file) {
        return;
      }
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      Axios.post(this.baseUrl + "/ppkpms/uploads/private", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myFile.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1;
        }).bind(this),
      })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.uploadedFiles = d.data;
            Axios.post(
              this.baseUrl + "/ppkpms/factory/order/attachFile",
              {
                orderId: this.$route.params.id,
                file: JSON.stringify(d.data[0]),
              },
              {
                headers: {
                  Authorization: "Bearer: " + localStorage.getItem("token"),
                },
              }
            )
              .then((res) => {
                if (res.status == 200) {
                  this.getTaskInfo();
                } else {
                  const title = (
                    <div>
                      <h5>خطا </h5>
                      <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                    </div>
                  );
                  this.toast(title, "error");
                }
              })
              .catch((err) => {
                this.toast(err.response.data, "error");
              });
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    printForm() {
      //printing receipt
      var myWindow = window.open("#", "Form", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title>Form</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("Form").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
      this.recLoaded = false;
    },
  },
  mounted() {
    this.getTaskInfo();
    this.role = window.localStorage.getItem("role");
    this.currentUserId = window.localStorage.getItem("userId");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.app-body {
  overflow-x: unset !important;
}
.table-product tbody tr:nth-child(even) {
  background-color: #f0f1f3 !important;
}
</style>
<style scoped>
.color1 {
  background-color: #aa879d;
  color: white;
  border: 0;
}

.color2 {
  background-color: #8e424f;
  color: white;
  border: 0;
}
.color3 {
  background-color: #60617d;
  color: white;
  border: 0;
}
.color4 {
  background-color: #bd5748;
  color: white;
  border: 0;
}
.color5 {
  background-color: #428e6d;
  color: white;
  border: 0;
}
.display {
  display: inline-block;
}
.orderInfoTable {
  border-radius: unset;
}
.orderInfoTable tr:nth-child(odd) {
  background-color: #d0d3d6;
}
</style>
